import { Collapsible } from '@ark-ui/react';
import cn from 'classnames';
import { useState } from 'react';

import { useDictionary } from 'src/hooks/useDictionary';
import { usePdfHelpers } from 'src/hooks/usePdfHelpers';

import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import Cta from 'components/BaseHelpers/Cta';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreRichTextData } from '../../../types/components';

import styles from './CoreRichText.module.scss';

export type CoreRichTextProps = ComponentProps & CoreRichTextData;

const CoreRichText = (props: CoreRichTextProps): JSX.Element => {
  const { eyebrow, heading, description, readMore, jumpLinkLabel } = props.fields;
  const { isPdf } = usePdfHelpers();
  const [accordionOpen, setAccordionOpen] = useState<boolean>(isPdf);
  const { readMoreLabel, readLessLabel } = useDictionary();

  if (!description) {
    return <></>;
  }

  return (
    <div className={cn(styles.main, 'container-10')} {...setJumpLinkAttributes(jumpLinkLabel)}>
      <Text className={cn(styles.eyebrow, 'body-eyebrow')} field={eyebrow} />
      <Text tag="h2" className={cn(styles.heading, 'heading-h3')} field={heading} />
      <RichText className={styles.description} field={description} />
      {readMore && (
        <Collapsible.Root
          className={styles['accordion']}
          tabIndex={accordionOpen ? -1 : undefined}
          open={accordionOpen}
          disabled={isPdf}
        >
          <Collapsible.Content className={styles['content']}>
            <RichText className={styles.description} field={readMore} />
          </Collapsible.Content>
          {isPdf ? null : (
            <Collapsible.Trigger className={styles.trigger} asChild={true}>
              <Cta
                tag="button"
                onClick={() => {
                  setAccordionOpen(!accordionOpen);
                }}
              >
                {accordionOpen ? readLessLabel : readMoreLabel}
              </Cta>
            </Collapsible.Trigger>
          )}
        </Collapsible.Root>
      )}
    </div>
  );
};

export default CoreRichText;
